import React from 'react';
import {
  Card, CardBody, Col, Progress,
} from 'reactstrap';
import {
  Link
} from "react-router-dom";
import { 
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
} from "../../../../../shared/helpers/utils";
import Icon from 'mdi-react/GridIcon';
import ToolTip from '../../../../../shared/components/ToolTip';

const TotalSqFt = (props) => (
	  <Col md={12} xl={4} lg={6} xs={6}>
	    <Card>
	    <Link to={`${props.location.pathname.replace('analysis', 'units')}`}>
	      <CardBody className="dashboard__booking-card card__link">
	        <div className="dashboard__booking-total-container">
	          <h5 className="dashboard__booking-total-title">
	            {props && props.buildingRes.ownership_type.toLowerCase().indexOf("condo")>=0 && props.statsRes && props.statsRes.total_sq_ft && props.statsRes.total_sq_ft.sum_sq_ft ? _formatNumber(props.statsRes.total_sq_ft.sum_sq_ft) : '--'}
	          </h5>
	          <Icon className="dashboard__trend-icon" />
	        </div>
	        <h5 className="dashboard__booking-total-description">Total Sellable Sq Ft <ToolTip 
			title={"Sum of all sellable units in this building excluding resident manager unit."} 
			
			/></h5>
	       
	      </CardBody>
	    </Link>
	    </Card>
	  </Col>
);

export default TotalSqFt;
